import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { DialogModel } from '../dialog.types';

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningComponent {
  constructor(
    private readonly matDialogRef: MatDialogRef<WarningComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogModel,
  ) {}

  ok(): void {
    this.matDialogRef.close();
  }

  get maxWidth(): string {
    return this.dialogData?.maxWidth || '600px';
  }

  get maxHeight(): string {
    return this.dialogData?.maxHeight || '290px';
  }
}
